import { View } from 'react-native';
import { useState } from 'react';

import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';
import Card from '@/components/ui/therapist/Card';
import { deleteUser, localLogoutUser } from '@/api/services/user';
import { DeleteAccountModal } from '@/components/DeleteAccountModal';
import { Modal } from '@/components/ui/therapist/Modal';
import { exportTherapistData } from '@/api/services/downloadUserData';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';

import { styles } from './styles';

export const Management: React.FC = () => {
  const { showNotification } = useNotification();

  const [isAccountDeletionModalVisible, setIsAccountDeletionModalVisible] =
    useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [value, setValue] = useState('');

  const cancelAccountDeletion = () => {
    setIsAccountDeletionModalVisible(false);
    setValue('');
  };

  const confirmAccountDeletion = async () => {
    cancelAccountDeletion();

    try {
      await deleteUser();
      await localLogoutUser(true);
    } catch {
      await localLogoutUser();
    }
  };

  const handleDownloadData = async () => {
    setShowConfirmationModal(false);
    const res = await exportTherapistData();
    if (!res.success) {
      showNotification({
        type: 'error',
        message:
          'Beim Exportieren der Datei ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
      });
    }
  };

  return (
    <>
      <Card title="Kontoverwaltung" styleBody={{ padding: 0 }}>
        <View style={[styles.itemContainer, { paddingTop: 20 }]}>
          <View style={styles.longLabelContainer}>
            <Text style={styles.label}>Kontoinformationen exportieren</Text>
            <Text>
              Laden Sie eine Datei mit Ihren bei uns gespeicherten persönlichen
              Daten herunter. Patient:innendaten sind davon ausgenommen.
            </Text>
          </View>
          <Button
            look="ghost"
            label="Exportieren"
            onPress={() => setShowConfirmationModal(true)}
          />
        </View>
        <View style={styles.divider}></View>
        <View style={[styles.itemContainer, { paddingBottom: 20 }]}>
          <View style={styles.longLabelContainer}>
            <Text style={styles.label}>Konto löschen</Text>
            <Text>
              Bitte beachten Sie, dass durch das Löschen Ihres neolexon-Kontos
              ein eventuell verknüpftes Abonnement nicht automatisch gekündigt
              wird.
            </Text>
          </View>
          <Button
            look="danger"
            label="Konto löschen"
            onPress={() => setIsAccountDeletionModalVisible(true)}
          />
        </View>
        <DeleteAccountModal
          isVisible={isAccountDeletionModalVisible}
          onClose={cancelAccountDeletion}
          onConfirm={confirmAccountDeletion}
          value={value}
          onChangeValue={(text) => setValue(text)}
        />
      </Card>

      <Modal
        isVisible={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        confirmActionButton={
          <Button label="Herunterladen" onPress={() => handleDownloadData()} />
        }
        cancelActionButton={
          <Button
            look="secondary"
            label="Abbrechen"
            onPress={() => setShowConfirmationModal(false)}
          />
        }
        title="Personenbezogene Daten herunterladen"
      >
        <Text>
          Wollen Sie Ihre personenbezogenen Daten wirklich herunterladen? Dies
          sollte nur auf eigenen Geräten durchgeführt werden, um zu verhindern,
          dass Unbefugte Zugriff auf die heruntergeladenen Daten erhalten.
        </Text>
      </Modal>
    </>
  );
};
